module.exports = __webpack_public_path__ + "img/slider-44.3a797da3.jpg";